import Entity from '../../../../core/domain/entity';
import UniqueEntityID from '../../../../core/domain/unique_entity_id';

export interface AppointmentProps {
  date: Date;
  duration?: string | undefined;
  comment?: string | undefined;
  location?: string | undefined;
  patientUserId?: string | undefined;
  createdAt?: Date | undefined;
  origin: string;
}

export class AppointmentId extends Entity<unknown> {
  private constructor(id?: UniqueEntityID) {
    super(null, id);
  }

  public static create(id?: UniqueEntityID): AppointmentId {
    return new AppointmentId(id);
  }
}

export class Appointment extends Entity<AppointmentProps> {
  get appointmentId() {
    return AppointmentId.create(this.id);
  }

  get date(): Date {
    return this.props.date;
  }

  get duration(): string | undefined {
    return this.props.duration;
  }

  get comment(): string | undefined {
    return this.props.comment;
  }

  get location(): string | undefined {
    return this.props.location;
  }

  get patientUserId(): string | undefined {
    return this.props.patientUserId;
  }

  get createdAt(): Date | undefined {
    return this.props.createdAt;
  }

  get origin(): string {
    return this.props.origin;
  }

  copyWith(props: AppointmentProps): Appointment {
    return Appointment.create(
      {
        ...this.props,
        ...props,
      },
      this.id,
    );
  }

  private constructor(props: AppointmentProps, id?: UniqueEntityID) {
    super(props, id);
  }

  public static create(
    props: AppointmentProps,
    id?: UniqueEntityID,
  ): Appointment {
    return new Appointment(props, id);
  }
}
